// extracted by mini-css-extract-plugin
export var pillWrapper = "_j9-0";
export var showOverflow = "_j9-1";